<template>
	<div class="login-body" id="login-body">
		<div class="login-page">
			<div class="form" id="login-form">
				<form class="login-form" @submit.prevent="Submit">
					<h1>Türkiye Buz Pateni Federasyonu</h1>
					<b-alert show variant="danger" v-if="errors.length">
						<ul class="m-0 p-0">
							<li v-for="e in errors" :key="e.id">{{e}}</li>
						</ul>
					</b-alert>
					<input type="text" autofocus="" v-model="credentials.email" placeholder="E-Posta"/>
					<input type="password" v-model="credentials.password" placeholder="Şifre"/>
					<!-- <button type="submit">Giriş</button> -->
										<button @click="checkForm" type="submit">Giriş</button>

					
				</form>
			</div>
		</div>
		<!-- <vue-recaptcha ref="invisibleRecaptcha" theme="dark" @verify="onVerify" @expired="onExpired" size="invisible" :sitekey="'6LcE0K4UAAAAALz_ug1nWjgpVqeR0nNncXEJogd6'"></vue-recaptcha> -->
	</div>

</template>
<script>
	import VueRecaptcha from 'vue-recaptcha';
	export default {
		props: [
		'isLogged'
		],
		data: function(){
			return {
				credentials:{
					email:null,
					password:null
				},
				isL : 'unknown',
				errors: []
			}
		},
		components: { VueRecaptcha },
		methods:{
			checkForm:function() {
				this.errors = [];
				if(!this.credentials.email) {
					this.errors.push("E-Posta Alanı Boş")
				}
				if(!this.credentials.password) {
					this.errors.push("Şifre Alanı Boş")
				}
				if(!this.validEmail(this.credentials.email)) {
					this.errors.push("E-Posta Formatı Doğru Değil")
				}
				if(!this.errors.length) {
					this.toggleLoader()
					this.tryLogin()
				}
			},
			validEmail:function(email) {
				var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				return re.test(email);
			},
			Submit: function () {
				// this.$refs.invisibleRecaptcha.execute()
			},
			onVerify: function (response) {
				this.checkForm()
			},
			onExpired: function () {
				console.log('Recaptcha Expired')
			},
			tryLogin: function(){
				this.$http.post('/api/users/login', this.credentials).then(
					response => {
						// Also can be achived with 'this.$parent.$data.isLoggedIn = true' but this is not a good idea
						this.isL = 'yes'
						this.$emit('changeState',this.isL)
						localStorage.setItem('CurrentLoggedUserDetails', JSON.stringify(response.body.Data));
						this.$router.push('/main')
						window.location.reload()
						this.getLimit()
						this.toggleLoader()
					},
					e => {
						this.errors.push(e.body.Error)
						this.toggleLoader()
					})
				// this.$refs.invisibleRecaptcha.reset()
			},
			getLimit () {
				if (!localStorage.getItem('filterLimit')) {
					this.$http.get('/api/settings/get/filter_limit').then((response) => {
						localStorage.setItem('filterLimit', response.body.data)
						location.reload()
					})
				} else {
					return localStorage.getItem('filterLimit')
				}
			}
		},
		mounted: function () {
			this.$nextTick(function () {
				setTimeout(function(){ 
					document.getElementById('login-body').classList.add('show');
					document.getElementById('login-form').classList.add('transition');
					setTimeout(function(){ 
						document.getElementById('login-form').classList.add('shadowed');
					}, 1000);
				}, 500);
				this.isL = this.isLogged
			})
		}

	}
</script>
<style>
.login-page {
	width: 360px;
	padding: 8% 0 0;
	margin: auto;
}
.form {
	position: relative;
	z-index: 1;
	background: #FFFFFF;
	max-width: 360px;
	margin: 0 auto 100px;
	padding: 45px;
	text-align: center;

	transform:translateY(-150%);
	transition-timing-function: ease-in;
	transition: .750s;
}
.form input {
	font-family: "Roboto", sans-serif;
	outline: 0;
	background: #f2f2f2;
	width: 100%;
	border: 0;
	margin: 0 0 15px;
	padding: 15px;
	box-sizing: border-box;
	font-size: 14px;
	transition: .300s;
}
.form input:focus {
	transform: scale(1.04);
	-webkit-box-shadow: 0px 0px 5px 1px rgba(118,184,82,.4);
	-moz-box-shadow: 0px 0px 5px 1px rgba(118,184,82,.4);
	box-shadow: 0px 0px 5px 1px rgba(118,184,82,.4);
}
.form button {
	font-family: "Roboto", sans-serif;
	text-transform: uppercase;
	outline: 0;
	background: #4CAF50;
	width: 100%;
	border: 0;
	padding: 15px;
	color: #FFFFFF;
	font-size: 14px;
	-webkit-transition: all 0.3 ease;
	transition: all 0.3 ease;
	cursor: pointer;
	transition: .500s;
}
.form button:hover,.form button:active,.form button:focus {
	background: #43A047;
	transform: scale(1.04);
}
.form .message {
	margin: 15px 0 0;
	color: #b3b3b3;
	font-size: 12px;
}
.form .message a {
	color: #4CAF50;
	text-decoration: none;
}
.form .register-form {
	display: none;
}
.container {
	position: relative;
	z-index: 1;
	max-width: 300px;
	margin: 0 auto;
}
.container:before, .container:after {
	content: "";
	display: block;
	clear: both;
}
.container .info {
	margin: 50px auto;
	text-align: center;
}
.container .info h1 {
	margin: 0 0 15px;
	padding: 0;
	font-size: 36px;
	font-weight: 300;
	color: #1a1a1a;
}
.container .info span {
	color: #4d4d4d;
	font-size: 12px;
}
.container .info span a {
	color: #000000;
	text-decoration: none;
}
.container .info span .fa {
	color: #EF3B3A;
}
.login-body {
	background: #76b852; /* fallback for old browsers */
	background: -webkit-linear-gradient(right, #76b852, #8DC26F);
	background: -moz-linear-gradient(right, #76b852, #8DC26F);
	background: -o-linear-gradient(right, #76b852, #8DC26F);
	background: linear-gradient(to left, #76b852, #8DC26F);
	font-family: "Roboto", sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale; 
	width: 100%;
	height: 100vh;  
	transition: 1s; 
	opacity: 0.01;  
}
.login-body.show{
	opacity: 1;
}
.form.transition{
	transform:translateY(0);
}
.form.shadowed{
	box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.24), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
}
ul {
	list-style-type: none;
}

</style>









// WEBPACK FOOTER //
// src/components/Dashboard/Views/Login.vue